import DefaultAvatar from './DefaultAvatar';

export default DefaultAvatar;
